<div class="sap-submittal-container d-flex flex-column">
    <div class="sap-submittal-content d-flex gap-3">
        <!-- Left section with error icon -->
        <div class="icon-section">
            <mat-icon class="warning-icon">error</mat-icon>
        </div>
        
        <!-- Right section with content -->
        <div class="content-section">
            <p class="dialog-paragraph">
                {{ 'SAP_SUBMITTAL_WARNING_PARAGRAPH_1' | translate }}
            </p>
            <p class="dialog-paragraph">
                {{ 'SAP_SUBMITTAL_WARNING_PARAGRAPH_2' | translate }}
            </p>
        </div>
    </div>
    
    <div class="sap-submittal-footer d-flex justify-content-end">
        <button mat-raised-button color="primary" (click)="requestSapSubmission()" >{{'OK' | translate}}</button>
        <button mat-raised-button color="warn" (click)="onCancel()" >{{'CANCEL' | translate}}</button>
    </div> 
</div> 